import { styled } from 'styled-components';

export const Container = styled.div<{ color: string }>`
  width: 100%;
  padding: 0.8rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 10px;

  svg {
    width: 1rem;
    height: 19px;
    color: ${({ color }) => color};
  }

  .tag {
    padding: 6px 10px;
    background: ${({ color }) => color};
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.white};
    text-transform: uppercase;
  }

  .message {
    text-align: center;
    font-size: 0.875rem;
    font-weight: bold;
    color: ${({ color }) => color};
    border-top: 1px solid ${({ theme }) => theme.colors.border};
    padding-top: 0.8rem;
    margin-top: 0.8rem;
  }
`;
